import { Globe } from 'lucide-react'
import { useTranslation } from '@/shared/i18n'
import { cn } from '@/shared/utils/helpers/cn'

interface LanguageSwitchProps {
  collapsed?: boolean
}

export function LanguageSwitch({ collapsed = false }: LanguageSwitchProps) {
  const { i18n } = useTranslation()
  const current = i18n.language === 'en' ? 'en' : 'fr'

  const change = (lng: 'fr' | 'en') => {
    if (lng !== current) i18n.changeLanguage(lng)
  }

  if (collapsed) {
    return (
      <button
        onClick={() => change(current === 'fr' ? 'en' : 'fr')}
        className="w-full flex flex-col items-center gap-0.5 py-1.5 rounded-lg text-white/50 hover:text-white/80 hover:bg-white/[0.04] transition-all"
        aria-label={current === 'fr' ? 'EN' : 'FR'}
      >
        <Globe size={14} />
        <span className="text-[9px] font-semibold uppercase">{current}</span>
      </button>
    )
  }

  return (
    <div className="flex items-center gap-1.5 py-1.5 px-1" role="group" aria-label="Language">
      <Globe size={12} className="text-white/30 shrink-0" />
      {(['fr', 'en'] as const).map((lng) => {
        const active = current === lng
        return (
          <button
            key={lng}
            onClick={() => change(lng)}
            aria-pressed={active}
            className={cn(
              'px-2 py-0.5 text-[10px] font-semibold uppercase rounded transition-all',
              active
                ? 'bg-white/[0.08] text-white'
                : 'text-white/40 hover:text-white/70 hover:bg-white/[0.04]',
            )}
          >
            {lng}
          </button>
        )
      })}
    </div>
  )
}
